import React, { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { collectionToStories } from "@quintype/components";
import { DfpComponent } from "../../ads/dfp-component";
import { RowSeparator } from "../../atoms/RowSeparator";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { getLoadMoreCollection } from "../../utils";
import StoryList from "./StoryList";
import "./three-col-nine-var-three.m.css";

export default function ThreeColumnNineStoriesVarThree({ collection, extraProp = "" }) {
  const initialSetStories = collectionToStories(collection);

  const [stories, setStories] = useState(initialSetStories);
  const [loadMoreStories, setLoadmoreStories] = useState([]);

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );
  const rowAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_ad_3_col_9_stories"], {})
  );

  const sectionSlug = extraProp;
  const associatedMetadata = get(collection, ["associated-metadata"], {});
  const rowAdUnitBottom = associatedMetadata.show_row_ad_unit_bottom || null;
  const showRowSeparator = associatedMetadata.show_row_separator || null;
  const showTimeStamp = associatedMetadata.show_timestamp || null;
  const showReadTime = associatedMetadata.show_read_time || null;
  const showStorySeparator = associatedMetadata.show_story_separator || null;
  const showLoadMore = associatedMetadata.show_load_more || null;
  const enableRowAd = associatedMetadata.enable_row_ad || null;
  const rowAdDetails = associatedMetadata.row_ad_details || "";

  const initialOffset = enableRowAd && rowAdDetails ? 8 : 9;
  const initialHasmore = enableRowAd && rowAdDetails ? stories?.length > 7 : stories?.length > 8;
  const [offset, setOffset] = useState(initialOffset);
  const [hasMore, setHasMore] = useState(initialHasmore);
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";

  if (!stories.length) return null;

  const handleLoadMore = async () => {
    await getLoadMoreCollection({
      offset: offset,
      limit: 8,
      slug: collection.slug,
      setLoadmoreStories: setLoadmoreStories,
      loadMoreStories: loadMoreStories,
      setStories: setStories,
      stories: stories,
      setHasMore: setHasMore,
    });
    setOffset((prevOffset) => prevOffset + 9);
  };
  return (
    <div className="row-component" styleName="top-component-wrapper">
      <div styleName={`${showStorySeparator ? "three-col-nine-var-three-with-separator" : "three-col-nine-var-three"}`}>
        <StoryList
          stories={stories}
          showStorySeparator={showStorySeparator}
          showTimeStamp={showTimeStamp}
          showReadTime={showReadTime}
          enableRowAd={enableRowAd}
          rowAdDetails={rowAdDetails}
          rowAdConfig={rowAdConfig}
          pageType={pageType}
          collection={collection}
          offset={offset}
          sectionSlug={sectionSlug}
        />
      </div>
      <div styleName="load-more-btn">
        {showLoadMore && hasMore && <button onClick={handleLoadMore}>LOAD MORE</button>}
      </div>
      {showRowSeparator && <RowSeparator />}
      {rowAdUnitBottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${pageType}-${collection.slug}-row-bottom-ad`}
          path={rowAdUnitBottom}
          size={bottomAdConfig.sizes}
          viewPortSizeMapping={bottomAdConfig.view_port_size_mapping}
        />
      )}
    </div>
  );
}

ThreeColumnNineStoriesVarThree.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
  }),
};

ThreeColumnNineStoriesVarThree.storyLimit = 9;
